/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";

function Footer() {
  return (
    <MKBox component="footer" py={6}>
      <Container>
        <Grid container spacing={3} justifyContent="center">
          {/* Columna 1: Logo */}
          <Grid item xs={12} md={4} textAlign="center" mb={{ xs: 3, md: 0 }}>
            <img
              src={require("assets/images/logo-seoul-new.png")}
              alt="Logo"
              style={{ maxWidth: 90, borderRadius: "5px" }}
            />
          </Grid>
          {/* Columna 2: Teléfonos */}
          <Grid item xs={12} md={4} textAlign="center" mb={{ xs: 3, md: 0 }}>
            <MKTypography variant="h6" mb={1}>
              Teléfonos
            </MKTypography>
            <MKTypography
              component="a"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.open("https://seoul.com.ar/track.php?c=whatsapp&p=ventas&o=web", "_blank", "noopener,noreferrer");
              }}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              display="block"
              mb={0.5}
            >
              Ventas: 011 5939-3230
            </MKTypography>
            <MKTypography
              component="a"
              href="#"
              onClick={(e) => {
                e.preventDefault();
                window.open("https://seoul.com.ar/track.php?c=whatsapp&p=service&o=web", "_blank", "noopener,noreferrer");
              }}
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              display="block"
            >
              Servicio técnico: 011 3468-3455
            </MKTypography>
          </Grid>
          {/* Columna 3: Redes sociales */}
          <Grid item xs={12} md={4} textAlign="center">
            <MKTypography variant="h6" mb={1}>
              Redes sociales
            </MKTypography>
            <MKTypography
              component="a"
              href="https://www.facebook.com/Seoul.Concesionario.Oficial.Hyundai"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={0.5}
            >
              <FacebookIcon sx={{ mr: 1 }} /> Facebook
            </MKTypography>
            <MKTypography
              component="a"
              href="https://www.instagram.com/seoulmotor/"
              target="_blank"
              rel="noopener noreferrer"
              variant="body2"
              display="flex"
              alignItems="center"
              justifyContent="center"
              mb={0.5}
            >
              <InstagramIcon sx={{ mr: 1 }} /> Instagram
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Footer;
